import { getCurrentInstance, onBeforeUnmount, onMounted } from 'vue';

// A nudge to reload the page's data without leaving it. The router doesn't
// re-create a page that's already open, so following a notification (or a
// new one arriving) for the current page would otherwise show stale rows.
const EVENT = 'app:page-refresh';

export function requestPageRefresh() {
  window.dispatchEvent(new CustomEvent(EVENT));
}

// Calls `reload` on each nudge while the calling component is mounted.
export function onPageRefresh(reload) {
  if (!getCurrentInstance()) return;
  const handler = () => reload();
  onMounted(() => window.addEventListener(EVENT, handler));
  onBeforeUnmount(() => window.removeEventListener(EVENT, handler));
}
